/**
 * LeadForm Module
 *
 * Handles AJAX submission for the mini "devis gratuit" form injected
 * on landing + locality pages. Validates fields, submits via fetch,
 * and shows success/error feedback.
 *
 * @module LeadForm
 */
export default class LeadForm {

  static DEFAULTS = {
    selector: '[data-lead-form]',
  };

  constructor() {
    this.forms = document.querySelectorAll(LeadForm.DEFAULTS.selector);
    if (!this.forms.length) return;

    this.forms.forEach((form) => this._initForm(form));
  }

  _initForm(form) {
    form.addEventListener('submit', (e) => this._handleSubmit(e, form));
  }

  async _handleSubmit(event, form) {
    event.preventDefault();

    const submitBtn = form.querySelector('.wleb-lead-form__submit');
    const feedback  = form.querySelector('[data-lead-feedback]');

    // Prevent double-submit
    if (submitBtn?.getAttribute('data-state') === 'loading') return;

    // Basic validation
    const name  = form.querySelector('[name="lead_name"]');
    const phone = form.querySelector('[name="lead_phone"]');

    if (!name?.value.trim() || !phone?.value.trim()) {
      this._showFeedback(feedback, 'Veuillez remplir votre nom et téléphone.', 'error');
      return;
    }

    // Phone format check
    if (!/^[+\d\s()./-]{7,20}$/.test(phone.value.trim())) {
      this._showFeedback(feedback, 'Veuillez saisir un numéro de téléphone valide.', 'error');
      return;
    }

    // Submit
    if (submitBtn) submitBtn.setAttribute('data-state', 'loading');
    this._hideFeedback(feedback);

    const ajaxUrl = form.getAttribute('data-ajax-url') || '/wp-admin/admin-ajax.php';

    try {
      const formData = new FormData(form);
      const response = await fetch(ajaxUrl, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        this._showFeedback(feedback, result.data?.message || 'Merci ! Nous vous recontactons sous 24h.', 'success');
        form.reset();

        // Track conversion (if GTM/GA present)
        if (typeof gtag === 'function') {
          gtag('event', 'generate_lead', {
            event_category: 'lead_form',
            event_label: form.querySelector('[name="page_title"]')?.value || '',
          });
        }
      } else {
        this._showFeedback(
          feedback,
          result.data?.message || 'Erreur lors de l\'envoi. Appelez-nous au 06 40 65 57 42.',
          'error'
        );
      }
    } catch {
      this._showFeedback(feedback, 'Erreur réseau. Appelez-nous au 06 40 65 57 42.', 'error');
    }

    if (submitBtn) submitBtn.removeAttribute('data-state');
  }

  _showFeedback(el, message, type) {
    if (!el) return;
    el.textContent = message;
    el.setAttribute('data-type', type);
    el.hidden = false;
  }

  _hideFeedback(el) {
    if (!el) return;
    el.hidden = true;
    el.textContent = '';
    el.removeAttribute('data-type');
  }

  destroy() {
    // No persistent listeners to clean up (submit is on form element,
    // will be GC'd with DOM).
  }
}
